import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useTheme } from "styled-components";
import Svg from "../Svg";
var Icon = function(props) {
    var theme = useTheme();
    var primaryColor = theme.isDark ? "#CECCDA" : "#093174";
    return /*#__PURE__*/ _jsx(Svg, _object_spread_props(_object_spread({
        width: "16",
        height: "16",
        viewBox: "0 0 16 16"
    }, props), {
        children: /*#__PURE__*/ _jsxs("svg", {
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ _jsx("path", {
                    d: "M1 3C1 2.73478 1.10536 2.48043 1.29289 2.29289C1.48043 2.10536 1.73478 2 2 2H14C14.2652 2 14.5196 2.10536 14.7071 2.29289C14.8946 2.48043 15 2.73478 15 3H1ZM8 11C8.53043 11 9.03914 10.7893 9.41421 10.4142C9.78929 10.0391 10 9.53043 10 9C10 8.46957 9.78929 7.96086 9.41421 7.58579C9.03914 7.21071 8.53043 7 8 7C7.46957 7 6.96086 7.21071 6.58579 7.58579C6.21071 7.96086 6 8.46957 6 9C6 9.53043 6.21071 10.0391 6.58579 10.4142C6.96086 10.7893 7.46957 11 8 11Z",
                    fill: primaryColor
                }),
                /*#__PURE__*/ _jsx("path", {
                    d: "M0 5C0 4.73478 0.105357 4.48043 0.292893 4.29289C0.48043 4.10536 0.734784 4 1 4H15C15.2652 4 15.5196 4.10536 15.7071 4.29289C15.8946 4.48043 16 4.73478 16 5V13C16 13.2652 15.8946 13.5196 15.7071 13.7071C15.5196 13.8946 15.2652 14 15 14H1C0.734784 14 0.48043 13.8946 0.292893 13.7071C0.105357 13.5196 0 13.2652 0 13V5ZM3 5C3 5.53043 2.78929 6.03914 2.41421 6.41421C2.03914 6.78929 1.53043 7 1 7V11C1.53043 11 2.03914 11.2107 2.41421 11.5858C2.78929 11.9609 3 12.4696 3 13H13C13 12.4696 13.2107 11.9609 13.5858 11.5858C13.9609 11.2107 14.4696 11 15 11V7C14.4696 7 13.9609 6.78929 13.5858 6.41421C13.2107 6.03914 13 5.53043 13 5H3Z",
                    fill: primaryColor
                })
            ]
        })
    }));
};
export default Icon;
